import { render, staticRenderFns } from "./NumberAuth.vue?vue&type=template&id=483b3bb5&scoped=true&"
import script from "./NumberAuth.vue?vue&type=script&lang=ts&"
export * from "./NumberAuth.vue?vue&type=script&lang=ts&"
import style0 from "./NumberAuth.vue?vue&type=style&index=0&id=483b3bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b3bb5",
  null
  
)

export default component.exports